import {
  getCoupon as callGetCoupon,
  putCoupon,
  getReward,
  postRedeemReward,
} from '../../../api/coupon.js';
import { switchLocale } from './appActions.js';
import { openAlert } from './alertActions.js';
import { mixpanel } from '~/third_party/Mixpanel.jsx';

const BASE = 'coupon :';

export const couponActionTypes = {
  getCoupon: `${BASE} fetch start`,
  getCouponSuccess: `${BASE} fetch SUCCESS`,
  getCouponFailed: `${BASE} fetch FAILED`,

  redeemCoupon: `${BASE} coupon redeem : persist start`,
  redeemCouponSuccess: `${BASE} coupon redeem : persist SUCCESS`,
  redeemCouponFailed: `${BASE} coupon redeem : persist FAILED`,

  checkReward: `${BASE} check reward : fetch start`,
  checkRewardSuccess: `${BASE} check reward : fetch SUCCESS`,
  checkRewardFailed: `${BASE} check reward : fetch FAILED`,

  redeemReward: `${BASE} reward redeem : persist start`,
  redeemRewardSuccess: `${BASE} reward redeem : persist SUCCESS`,
  redeemRewardFailed: `${BASE} reward redeem : persist FAILED`,
};

export const getCoupon = (code) => async (dispatch) => {
  try {
    dispatch({
      type: couponActionTypes.getCoupon,
    });
    const { data } = await callGetCoupon(code);
    const { language } = data.attributes;
    dispatch(switchLocale(language));
    dispatch({
      type: couponActionTypes.getCouponSuccess,
      coupon: data,
    });
  } catch (e) {
    dispatch({
      type: couponActionTypes.getCouponFailed,
    });
  }
};

export const redeemCoupon = (code) => async (dispatch) => {
  try {
    dispatch({
      type: couponActionTypes.redeemCoupon,
    });
    await putCoupon(code);
    dispatch({
      type: couponActionTypes.redeemCouponSuccess,
    });
  } catch (e) {
    dispatch({
      type: couponActionTypes.redeemCouponFailed,
    });
  }
};

export const checkReward = ({ orderNumber, referrerId }) => async (dispatch) => {
  dispatch({
    type: couponActionTypes.checkReward,
  });
  try {
    await getReward({ orderNumber, referrerId });
    dispatch({
      type: couponActionTypes.checkRewardSuccess,
    });
    mixpanel.track({
      name: 'user opens redeem point page',
      properties: { status: 'not redeemed yet' },
    });
  } catch (e) {
    dispatch({
      type: couponActionTypes.checkRewardFailed,
    });
    mixpanel.track({ name: 'user opens redeem point page', properties: { status: 'redeemed' } });
  }
};

export const redeemReward = ({ orderNumber, referrerId, phoneNumber, restaurantIds }) => async (
  dispatch,
  getState,
  { intl }
) => {
  const { formatMessage } = intl(getState());
  dispatch({
    type: couponActionTypes.redeemReward,
  });
  try {
    await postRedeemReward({ orderNumber, referrerId, phoneNumber, restaurantIds });
    dispatch(
      openAlert({
        variant: 'success',
        message: formatMessage({ id: 'page.reward.redeem.alert.success' }),
      })
    );
    dispatch({
      type: couponActionTypes.redeemRewardSuccess,
    });
    mixpanel.track({ name: 'user redeems the point successfully' });
  } catch (e) {
    dispatch(
      openAlert({
        variant: 'error',
        message: formatMessage({ id: 'page.reward.redeem.alert.failed' }),
      })
    );
    dispatch({
      type: couponActionTypes.redeemRewardFailed,
    });
  }
};
